import { useEffect, useState } from "react";
import _ from "lodash";
import { useApi, useHealthCenterRules } from "../../../../../utils/hooks";

const usePatientSearchStrategy = () => {
  const [patients, setPatients] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const api = useApi();
  const searchStrategy = useHealthCenterRules("patients")?.search?.strategy;
  const shouldSearchAsync = searchStrategy == "async";

  useEffect(() => {
    if (shouldSearchAsync) return;

    api.patients()
      .tap(setPatients)
      .finally(() => setIsLoading(false));
  }, []);

  const onAsyncSearch = (search) => {
    return api.patients({ search });
  };

  const strategyProps = shouldSearchAsync
    ? { onAsyncSearch }
    : { patients, loading: isLoading };

  return {
    strategyProps
  };
};

export default usePatientSearchStrategy; 